/** @internal for {@see UIDPubSub} */
export class MapOrSetDefault<T, K = string> extends Map<K, T> {
  constructor(private _default: (key: K) => T) {
    super();
  }
  update(key: K, from: (current: T) => T): void {
    // biome-ignore lint/style/noNonNullAssertion: duh
    this.set(key, from(this.has(key) ? this.get(key)! : this._default(key)));
  }
  getOrSetDefault(key: K): T {
    // biome-ignore lint/style/noNonNullAssertion: duh
    return this.has(key) ? this.get(key)! : this._setDefault(key);
  }
  private _setDefault(key: K): T {
    const val = this._default(key);
    this.set(key, val);
    return val;
  }
}
